import { memo } from 'react'

import { FilterType } from '@/types/additionalFilters'
import { CardListType } from '@/types/card'

import JumpTo from '../JumpTo/JumpTo'

import ControlsDesktop from './ControlsDesktop'
import ControlsMobile from './ControlsMobile'

type Props = {
  cardLists: CardListType[]
  currentElementIndexInViewport: number
  disabledSortMethods?: string[]
  enableCount?: boolean
  filters: FilterType[]
  groupedBy?: string
  hideControls?: boolean
  hideHeader?: boolean
  loading: boolean
  persist: boolean
  setFilters: (filters: FilterType[]) => void
  togglePersist: () => void
  sortedBy?: string
  updatedAt: number
}

const CardListsHeader = ({
  cardLists,
  currentElementIndexInViewport,
  disabledSortMethods,
  enableCount,
  filters,
  groupedBy,
  hideControls,
  hideHeader,
  loading,
  persist,
  setFilters,
  togglePersist,
  sortedBy,
  updatedAt,
}: Props) => {
  return (
    <>
      <JumpTo
        cardLists={cardLists}
        currentElementIndexInViewport={currentElementIndexInViewport}
        enableCount={enableCount}
        hideHeader={hideHeader}
        updatedAt={updatedAt}
      >
        {hideControls || (
          <ControlsMobile
            disabledSortMethods={disabledSortMethods}
            filters={filters}
            groupedBy={groupedBy}
            persist={persist}
            setFilters={setFilters}
            togglePersist={togglePersist}
            sortedBy={sortedBy}
          />
        )}
      </JumpTo>
      {hideControls || (
        <ControlsDesktop
          //cardLists={cardLists}
          disabledSortMethods={disabledSortMethods}
          filters={filters}
          groupedBy={groupedBy}
          //loading={loading}
          persist={persist}
          setFilters={setFilters}
          togglePersist={togglePersist}
          sortedBy={sortedBy}
        />
      )}
    </>
  )
}

export default memo(CardListsHeader)
